import { get } from 'lodash';
import { isEmpty } from '@/common/helpers';
import {
    defaultState as baseState,
    mutations as baseMutations,
    actions as baseActions
} from './searchBase';

export const defaultState = {
    entityName: 'activities',
    baseUrl: 'api/venueEvents/',
    tableName: 'venueEventsTable',
    ...baseState,
    eventTypeOptions: [],
    helpUrl: '/user-guide/guide/recent-activities.html'
};

export const mutations = {
    ...baseMutations,
    setEventTypeOptions(state, value) {
        state.eventTypeOptions = Array.isArray(value) ? value : [];
    }
};

export const actions = {
    ...baseActions,
    fetchVenueEvents(
        { commit, dispatch, state },
        { searchParams, filterParams }
    ) {
        console.log('calling fetchVenueEvents', searchParams, filterParams);
        // const currentVenue = rootGetters['venue/currentVenue'];
        const notifyConfig = {
            notifyRequestPending: true
        };
        return dispatch('fetchItems', {
            searchParams,
            filterParams: {
                ...filterParams
            },
            notifyConfig,
            saveParams: true,
            isDsSearch: false
        }).then(res => {
            const { content, ...page } = res.data;
            commit('setItems', content);
            commit('setResponseQuery', { ...page });
            commit('setRequestQuery', {
                ...state.requestQuery,
                size: page.size,
                number: page.number
            });
        });
    },
    fetchActivityOptions({ commit, state }) {
        console.log('calling fetchActivityOptions');
        if (!isEmpty(state.optionsConfig)) {
            const eventTypes =
                get(state.optionsConfig, 'eventTypeOptions') || [];
            commit('setEventTypeOptions', eventTypes);
        }
    }
};

export default {
    namespaced: true,
    state: defaultState,
    mutations,
    actions
};
